import React, { useState } from "react";

function Pageloader() {
    const [isVisible, setIsVisible] = useState(true);

    const closeLoader = () => setIsVisible(false);

    if (!isVisible) return null;

    return (
        <div className="mainsld-overlay">
            <div className="closeLoader" onClick={closeLoader}>
                ✕
            </div>
            <div className="welcome-card">
                <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Welcomelogo.jpg"
                    alt="School Logo"
                    className="logo-img"
                />
                <h2>Welcome To</h2>
                <h1>The Frank Anthony Junior School<br />
                    Bengaluru</h1>
                <button className="enter-btn" onClick={closeLoader}>
                    Enter Website
                </button>
            </div>
        </div>
    );
}

export default Pageloader;